/**
 * TaskCompletedContent - Renders content for TaskCompleted timeline events
 * Shows completed task name and actor
 */

import React from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';

interface TaskCompletedContentProps {
  event: TimelineEvent;
}

const TaskCompletedContent: React.FC<TaskCompletedContentProps> = ({ event }) => {
  const { t } = useTranslation();

  const taskName = event.payload?.taskName ?? '';
  const actor = event.payload?.completedBy ?? event.actor ?? '';

  return (
    <div className="sphere-timeline-event__content-block">
      <p className="sphere-timeline-event__description">
        {t('activityFeed.events.taskCompleted', {
          actor: String(actor),
          taskName: String(taskName),
        })}
      </p>
    </div>
  );
};

export default TaskCompletedContent;
